import {ActionIcon, Button, FileInput, Modal} from "@mantine/core";
import React, {useEffect, useMemo, useRef, useState} from "react";
import IconAddFile from "../../Icon/IconAddFile";
import {useForm} from "@mantine/form";
import axiosInstance from "../../Helper/axiosInstance";
import IconFileTrash from "../../Icon/IconFileTrash";
import IconFileAdd from "../../Icon/IconFileAdd";
import IconTrashLogo from "../../Icon/IconTrashLogo";
import {useParams} from "react-router-dom";
import {notifications} from "@mantine/notifications";
import {v4 as uuidv4} from 'uuid';
import {mimeTypeConvertor} from "../Helper/mimeTypeConvertor";
import {isAxiosError} from "axios";


const UploadStatus = Object.freeze({
    PENDING: 'PENDING', FAILED: 'FAILED', SUCCESS: 'SUCCESS', UPLOADING: 'UPLOADING',
})

const MAX_RETRIES = 3;
const CONCURRENT = 4;
const PROCESS_REST = 500;

const UserInputForm = ({setUploadComplete}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [uploadedPercentage, setUploadPercentage] = useState("0%");
    const queue = useRef([]);
    const fileUrl = useRef('');
    const processQueue = useRef([]);
    const [fileNotAcceptable, setFileNotAcceptable] = useState(false);
    const [uploadStatus, setUploadStatus] = useState(null);
    const intervalHandler = useRef();
    const progressPercentageRef = useRef(null);
    const {id} = useParams();
    const validFileTypes = useMemo(() => {
        let output = localStorage.getItem('ext') ?? '';
        if (output.includes('video/mp4')){
            output += ',video/mov,video/quicktime';
        }
        return output;
    }, []);


    const filePlaceHolder = <div className="flex justify-between min-w-full  text-center" dir="ltr"><IconAddFile
        className="text-greenTwo"/><p>اضافه کردن فایل</p></div>;
    const modalDeleteHandler = (isUserSure) => {
        if (!isUserSure) {
            setIsModalOpen(false)
            return
        }
        form.setFieldValue('file', null);
        setIsModalOpen(false);
    }


    const form = useForm({
        initialValues: {file: null}, validate: {
            file: (value) => value ? (value.size >= 210_000_000 ? ' فایل باید کمتر از 200 مگابایت باشد' : null) : 'لطفا فایلی را انتخاب کنید'
        },
    });

    const removeFileFromProcess = (file) => {
        const itemIndex = processQueue.current.findIndex(item => item?.index === file?.index);
        if(itemIndex)  processQueue.current.splice(itemIndex, 1);
    }


    const uploadFile = (file) => {
        if (!file) return;
        file.status = UploadStatus.UPLOADING;
        file.retries += 1;
        const ext = file.fileName.split('.').at(-1);

        const phoneNumberFromServer = localStorage.getItem('phoneNumber')


        return axiosInstance.post(`https://upload.shad.ir/api/Upload/UploadChunk/${file.index-1}/${file.fileSize}/${phoneNumberFromServer}-${file.fileName}?generateUniqueFilename=true&createSubFolder=shad/${id}`, {file: file.chunk}, {
            headers: {
                pwa: "=9YoDR6@06*0-X8PXc~[R2=d]_~NDCL{Ou)Y'9n{",
                "Content-Type": "multipart/form-data",
            }
        },).then(({data}) => {
            if (data.status === 'complete'){
                fileUrl.current = data.downloadUrl;
            }
            file.status = UploadStatus.SUCCESS;
            removeFileFromProcess(file);
        }).catch((err) => {
            if (isAxiosError(err) && err.response?.status === 400){
                setFileNotAcceptable(true);
            }
            file.status = UploadStatus.FAILED;
            removeFileFromProcess(file);
        })
    }

    const submitFileToEvent = (fileUrl) => {
        if (!fileUrl) return Promise.reject('not included fileUrl');

        const phoneNumberFromServer = localStorage.getItem('phoneNumber')
        return axiosInstance.post(`https://shadeventapi.noyanet.com/Shad/v2/RegisterFile`, {
            mobile: phoneNumberFromServer,
            eventId: Number(id),
            downloadUrl: fileUrl
        })
    }



    const isValidFileType = (fileExt) => {
        const defaultExt = ["jpg", "jpeg", "png", "gif", "gif", "webp", "pdf", "mp4", "mov", "mkv", "avi", "heic", "heic", "mp3", "wav", "ogg", "zip", "rar", "rar", "doc", "docx", "xls", "xlsx", "ppt", "pptx"];

        if (validFileTypes.includes('*')){
            return defaultExt.includes(fileExt);
        }

        return validFileTypes.includes(mimeTypeConvertor(fileExt));

    }

    const submitHandler = form.onSubmit((values) => {
        const extension = values.file.name.split('.').at(-1).toLowerCase();

        if(!isValidFileType(extension)){
            notifications.show({
                title: 'خطا',
                message:'فرمت فایل انتخاب شده صحیح نمی‌باشد',
                color:'red',
            })
            form.reset();
            return;
        }
        const chunkSize = 1024 * 1024; // size of each chunk (1MB)
        let start = 0;
        let index = 1;
        const uuid = uuidv4();

        while (start < values.file.size) {
            const chunk = (values.file.slice(start, start + chunkSize, values.file.type));
            //chunk.slice(0, chunk.size,)

            queue.current.push({
                uuid, retries: 0, status: UploadStatus.PENDING, chunk: chunk, index, fileName: values.file.name, fileSize: values.file.size
            });
            start += chunkSize;
            index++;
        }
        setUploadStatus(UploadStatus.UPLOADING)
    });


    const onFinish = () => {
        clearInterval(intervalHandler.current);
        processQueue.current = [];
        queue.current = [];
        form.setFieldValue('file',null);
    }

    useEffect(() => {

        if (uploadStatus === null || intervalHandler.current) return () => {
        };

        intervalHandler.current = setInterval(() => {
            const completedCount = queue.current.filter(item => item.status === UploadStatus.SUCCESS).length;

            if (progressPercentageRef.current){
                const upload = (completedCount/queue.current.length)*100;
                progressPercentageRef.current.style.width = `${upload.toFixed(0)}%`;
                setUploadPercentage(`${upload.toFixed(0)}%`)
            }

            if (completedCount === queue.current.length) {
                setUploadStatus(UploadStatus.SUCCESS);
                submitFileToEvent(fileUrl.current).then(() => {
                    setUploadComplete(true);
                    onFinish()
                }).catch(() => {
                    onFinish()
                })



                return;
            }

            const failedCount = queue.current.filter(item => item.status === UploadStatus.FAILED && item.retries > 3).length;
            if (failedCount >= MAX_RETRIES) {
                setUploadStatus(UploadStatus.FAILED);
                notifications.show({
                    title: 'عدم ارتباط با سرور',
                    message: 'اتصال اینترنت خود را بررسی کنید و دقایقی بعد تلاش کنید',
                    color: 'red',
                })
                onFinish()
                return;
            }



            const pendings = queue.current.filter(item => [UploadStatus.PENDING, UploadStatus.FAILED].includes(item.status));
            if (pendings.length < 1) return;


            const remainsConcurrent = CONCURRENT - processQueue.current.length;

            if (remainsConcurrent < 1) return;

            for (let x = 0; x < remainsConcurrent - 1; x++) {
                processQueue.current.push(uploadFile(pendings[x]))
            }
        }, PROCESS_REST)

        return () => {
            onFinish()
        }
    }, [uploadStatus]);


    useEffect(() => {
        if (!fileNotAcceptable) return;

        notifications.show({
            id: 1,
            title: 'خطا',
            message: 'این فایل برای انتخاب مجاز نمیباشد لطفا از فایل دیگری تلاش نمایید.',
            color: 'red',

        })
        form.reset();
        processQueue.current = [];
        queue.current = [];
        clearInterval(intervalHandler.current);
        intervalHandler.current = null;
        setFileNotAcceptable(false);
        setUploadStatus(null);

    }, [fileNotAcceptable])

    return (<div className="overflow-hidden">


            <form onSubmit={submitHandler} className="flex flex-col justify-center items-center h-full p-5">

                {
                    uploadStatus !== UploadStatus.UPLOADING ? (
                        <FileInput
                            accept={`${validFileTypes}`}
                            className={ ` text-sm text-red-40 w-full mb-10 mx-10 sm:max-w-[400px] placeholder:text-center ${ form.values.file  && 'bg-greenOne'}`}
                            leftSection={<IconFileAdd
                                className={`${form.values.file ? "text-greenTwo" : "text-gray-400"}`}/>}
                            rightSection={form.values.file && <ActionIcon onClick={() => setIsModalOpen(true)}><IconFileTrash
                                className="text-red-400"/></ActionIcon>}
                            radius="md"
                            placeholder={filePlaceHolder ?? ''}
                            size='xl'
                            {...form.getInputProps('file')}
                        />
                    ) : (
                        <div className="w-full  flex flex-col items-center justify-center p-4 gap-5 mb-5">
                            <div className=" flex gap-3 min-w-full items-center text-greyOne ">
                                <IconFileAdd />
                                <span> {form.values.file.name}</span>
                            </div>

                            <div
                                dir={"rtl"}
                                className="h-5 rounded-2xl w-full bg-neutral-200 flex  "
                            >
                                <div
                                    className="h-full rounded-2xl bg-greenTwo transition-all duration-500 text-xl text-white text-left pl-3"
                                    ref={progressPercentageRef}
                                >{uploadedPercentage < '2%' ? null : uploadedPercentage}</div>
                            </div>
                        </div>
                    )}

                <Button size="lg"
                        className="bg-greenTwo hover:bg-white hover:text-greenTwo hover:border-2 hover:border-greenTwo w-full max-w-[200px]"
                        disabled={ uploadStatus === UploadStatus.UPLOADING }
                        type="submit"
                        radius="md">ارسال</Button>
            </form>


        <Modal opened={isModalOpen} onClose={() => setIsModalOpen(false)} centered className="min-h-full"
               radius="lg" withCloseButton={false} closeOnClickOutside={false} closeOnEscape={false}>
            <div className="min-w-full min-h-full flex flex-col justify-evenly  items-center gap-y-10">
                <IconTrashLogo className="bg-red-500 text-white p-2 rounded-full mb-4"/>
                <p className="text-greyTwo text-مل sm:text-xl "> آیا میخواهید فایل مورد نظر را پاک کنید؟</p>
                <div className="min-w-full flex justify-between mx-10 gap-8">

                    <Button onClick={() => modalDeleteHandler(true)}
                            className="flex-1 text-white bg-red-500 hover:bg-white hover:text-red-500 hover:border-2 hover:border-red-500  "
                            size="md">بله </Button>
                    <Button onClick={() => modalDeleteHandler(false)}
                            className="flex-1 text-greenTwo bg-white border-2 border-greenTwo hover:text-white hover:bg-greenTwo  "
                            size="md">خیر</Button>
                </div>
            </div>
        </Modal>
    </div>)
}
export default UserInputForm;
